// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"144c627c","619":"69131d82","655":"66e0837b"}[chunkId] + ".chunk.js";
};